module.exports = __webpack_public_path__ + "static/media/cp86.b362bea6.jpg";